export const DefaultPagination = {
  START_PAGE: 1,
  PAGE_LIMIT: 10,
};

export const PageSizeOptions = [10, 25, 50, 100];
